import { useQuery } from "@tanstack/react-query";
import { useNavigate, useSearchParams } from "react-router";
import { FolderKanban, ShieldQuestion, Sparkles } from "lucide-react";
import { useApi } from "@ncp/api-client";
import { useTranslation } from "@ncp/i18n";
import { Badge, Button, PageHeader, Tabs, TabsContent, TabsList, TabsTrigger, Tooltip } from "@ncp/ui";
import { CaseRegisterTable } from "../features/registers/CaseRegister";
import { ScreeningQueue } from "../features/case/ScreeningQueue";

/** The Economic Concentration section: every notification on one page, and the intake screening of filings the control test flagged. */
export function EconomicConcentrationPage() {
  const { t } = useTranslation();
  const api = useApi();
  const [params, setParams] = useSearchParams();
  const navigate = useNavigate();
  const tab = params.get("tab") ?? "requests";
  const screening = useQuery({ queryKey: ["ec-screening-queue"], queryFn: () => api.get<unknown[]>("/api/ec/screening-queue") });

  return (
    <div>
      <PageHeader
        title={t("nav.economicConcentration")}
        actions={<Tooltip content={t("backoffice:agentic.entryHint")}><Button variant="gold" onClick={() => navigate("/concentration/agentic")}><Sparkles /> {t("backoffice:agentic.entry")}</Button></Tooltip>}
      />
      <Tabs value={tab} onValueChange={(v) => setParams((p) => { p.set("tab", v); return p; })}>
        <TabsList variant="underline" className="mb-4">
          <TabsTrigger value="requests" variant="underline"><FolderKanban /> {t("backoffice:sections.ec.requests")}</TabsTrigger>
          <TabsTrigger value="screening" variant="underline"><ShieldQuestion /> {t("backoffice:sections.ec.screening")} <Badge size="sm" variant={screening.data?.length ? "warning" : "outline"}>{screening.data?.length ?? 0}</Badge></TabsTrigger>
        </TabsList>
        <TabsContent value="requests"><CaseRegisterTable type="EconomicConcentration" /></TabsContent>
        <TabsContent value="screening">
          <ScreeningQueue />
        </TabsContent>
      </Tabs>
    </div>
  );
}
